import React from "react";
import styled from "styled-components";

const CustomRadioButton = ({
  label,
  value,
  checked,
  register,
  validationRules,
  name,
  className,
  disabled,
  color,
  cursorPointer,
}) => {
  return (
    <RadioWrapper
      style={{ cursor: cursorPointer && cursorPointer }}
      checked={checked}
      className={`${className ? className : ""}`}
      disabled={disabled}
    >
      <input
        className="radio-input"
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        {...(register && register(name, validationRules))}
      />
      <span
        style={{ color: color && color }}
        className="radio-text mx-2"
        checked={checked}
      >
        {label}
      </span>
    </RadioWrapper>
  );
};

export default CustomRadioButton;

const RadioWrapper = styled.label`
  display: flex;
  align-items: end;
  width: 100%;
  padding: 11px 15px;
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: ${(props) => (props?.disabled ? "not-allowed" : "pointer")};
  border: 1px solid
    ${(props) => (props.checked ? "var(--themeColor)" : "var(--border)")};
  background-color: ${(props) =>
    props.disabled ? "var(--bgSecondary)" : "var(--white)"};
    

  .radio-input {
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid var(--border);
  border-radius: 50%;
  background-color: var(--white);
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
}

.radio-input:checked {
  border: 2px solid var(--themeColor); 
}

.radio-input:checked::after {
  content: "";
  width: 10px;
  height: 10px;
  background-color: var(--themeColor); 
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


  .radio-text {
    font-weight: ${(props) => (props.checked ? "bold" : "normal")};
    color: ${(props) => (props.checked ? "var(--themeColor)" : "var(--text)")};
  }
`;
